import React, { useEffect, useRef, useState } from "react";
import Style from "./style.module.css";

import { Alert, Skeleton, Snackbar } from "@mui/material";
import CompanySettingAddUpdate from "../../../modal";
import { useApiCall } from "../../../../../../component/custom-hooks/api-call";
import InnerLoader from "../../../../../../component/ui/loader/inner-loader";
import DataNotFound from "../../../../../../component/ui/loader/data-not-found";
import {
  Table,
  TableBody,
  TableCard,
  TableCell,
  TableFilterReturn,
  TableHead,
  TableHeaderWrap,
  TableRow,
  TableSort,
} from "../../../../../../component/table/table-layout";
import DynamicFilter from "../../../../../../component/table/filter-table/dynamic-filter";
import CustomizeTabsPopup from "../../../../../../component/table/customize-table";
import LayoutTopIcon from "../../../../../../component/icons/layout-top";
import FilterFunnel01Icon from "../../../../../../component/icons/filter-funnel-01";
import Tooltip from "../../../../../../component/ui/tooltip";
import NewEditIcon from "../../../../../../component/icons/action-edit-icon";
import StatusChip from "../../../../../../component/ui/chip/status";
import ChevronDownIcon from "../../../../../../component/icons/chevron-down";

const SettingsProductsPackages = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [apiData, setApiData] = useState([]);
  const [showModalFilterTable, setShowModalFilterTable] = useState(false);
  const [filterReturn, setFilterReturn] = useState([]);
  const [saveFilter, setSaveFilter] = useState([]);
  const [tablePagination, setTablePagination] = useState({});
  const [btnLoader, setBtnLoader] = useState(false);
  const [alertData, setAlertData] = useState({ isShow: false });

  const [showModalCustomizeTabs, setShowModalCustomizeTabs] = useState(false);
  const [tableHeader, setTableHeader] = useState([]);

  const [currentData, setCurrentData] = useState({});
  const [showEditModal, setShowEditModal] = useState(false);
  const [products, setProducts] = useState([]);

  const [pageCount, setPageCount] = useState(1);
  const [pageItemsCount, setPageItemsCount] = useState(10);
  const [sortFields, setSortFields] = useState([]);
  const [selectFilterName, setSelectFilterName] = useState("My Filter");
  const [editingFilters, setEditingFilters] = useState(null);

  const handleClose = () => {
    setAlertData({ isShow: false });
  };

  const apiCall = useApiCall();

  useEffect(() => {
    getData({});
    // getCategory();
  }, []);

  const handleSingleSort = (field) => {
    setPageCount(1);
    setSortFields((prev) => {
      let currentSort = prev[0]; // Assume prev is an array with max 1 object
      let newSortField;
      if (currentSort && currentSort.field === field) {
        if (currentSort.order === "desc") {
          newSortField = { field, order: "asc" };
        } else if (currentSort.order === "asc") {
          newSortField = null;
        }
      } else {
        newSortField = { field, order: "desc" };
      }
      const finalSortFields = newSortField ? [newSortField] : [];
      // Trigger the filter with the updated sort
      filterData({ sortField: finalSortFields, page: 1 });
      return finalSortFields;
    });
  };

  const filterData = ({
    filters = filterReturn,
    page = pageCount,
    page_quantity = pageItemsCount,
    sortField = sortFields,
    btnCall = false,
  }) => {
    const sort_by = sortField[0]?.field || null;
    const sort_direction = sortField[0]?.order || null;
    const data = {
      page,
      page_quantity,
      filters,
      sort_by,
      sort_direction,
      btnCall,
    };
    getData(data);
  };

  const getData = async (data = null) => {
    if (data?.btnCall) {
      setBtnLoader(true);
    } else {
      setIsLoading(true);
    }
    let urlData = ``;
    if (data) {
      urlData = !data?.page
        ? `&page_quantity=10&page=1`
        : `&page=${data?.page}${
            data?.page_quantity !== "all"
              ? `&page_quantity=${data?.page_quantity}`
              : ""
          }`;
      if (data?.filters) {
        data?.filters.forEach((el) => {
          const key = el.field || el.name; // support both
          if (key === "date_filter" && el.value === "between") {
            if (el.startDate) {
              urlData += `&date_filter=custom&start_date=${el?.startDate}`;
            }
            if (el.endDate) {
              urlData += `&end_date=${el?.endDate}`;
            }
          } else if (el?.value !== "" && el?.value != null) {
            urlData += `&${key}=${el.value}`;
          }
        });
      }
      if (data?.sort_by && data?.sort_direction) {
        urlData += `&sort_by=${data.sort_by}&sort_direction=${data.sort_direction}`;
      }
    }

    try {
      let res = await apiCall({
        url: `sales/packages-products?${urlData}`,
        method: "get",
      });
      if (data?.btnCall) {
        setBtnLoader(false);
        setApiData((prev) => [...prev, ...res.data]);
      } else {
        setApiData(res.data);
      }
      setTableHeader(res?.applied_headers);
      setSaveFilter(res?.custom_filters);
      setTablePagination(res?.pagination);
      setBtnLoader(false);
      setIsLoading(false);
    } catch (error) {
      console.warn("Err", error);
    }
  };

  const onSuccess = (message) => {
    setAlertData({ isShow: true, type: "success", message: message });
    setShowEditModal(false);
    setCurrentData({});
    setSubProductModal(false);
    setSubProductData({});
    getData({});
  };

  const onError = (message) => {
    setAlertData({ isShow: true, type: "error", message: message });
  };

  const editProduct = (data) => {
    setCurrentData(data);
    setShowEditModal(true);
  };

  const [categories, setCategories] = useState([]);

  const getCategory = async () => {
    try {
      let res = await apiCall({
        method: "get",
        url: `products/products-list-settings`,
      });
      console.log("Categoirews", res);
      setCategories(res?.data);
    } catch (error) {}
  };

  const filterModalData = [
    {
      name: "search",
      label: "Product",
      options: ["contains"],
      selectedOpt: "contains",
      value: "",
      type: "text",
    },
    {
      name: "package_name",
      label: "Package",
      options: ["contains"],
      selectedOpt: "contains",
      value: "",
      type: "text",
    },
    {
      name: "features",
      label: "Features",
      options: ["contains"],
      selectedOpt: "contains",
      value: "",
      type: "text",
    },
    {
      name: "frequency",
      label: "frequency",
      options: ["contains"],
      selectedOpt: "contains",
      value: "",
      type: "text",
    },
  ];

  const [productPackages, setProductPackages] = useState([]);
  const [subProductModal, setSubProductModal] = useState(false);
  const [subProductData, setSubProductData] = useState({});
  const [spLoading, setSpLoading] = useState(false);

  const [openRow, setOpenRow] = useState("");

  const toggleRow = (id) => {
    if (id == openRow) {
      setOpenRow("");
      setProductPackages([]);
      return;
    }

    setOpenRow(id);
    getProductPackages(id);
  };

  const getProductPackages = async (id) => {
    setSpLoading(true);
    try {
      const res = await apiCall({
        method: "get",
        url: `sales/products-packages/${id}`,
      });
      console.log("res", res);

      setProductPackages(res?.data);
    } catch (error) {
      console.warn("Error : ", error);
    } finally {
      setSpLoading(false);
    }
  };

  const editSubProduct = (eachList) => {
    setSubProductData(eachList);
    setSubProductModal(true);
  };

  const tableRef = useRef(null);

  function formatText(str) {
    if (!str) return "--";

    return str
      .replace(/[-_]+/g, " ") // replace hyphens & underscores with space
      .toLowerCase() // normalize
      .split(" ") // split into words
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }

  function extractListItems(html) {
    if (!html) return [];

    return (
      html
        .replace(/<\/?ul>/g, "") // remove <ul> tags
        .match(/<li>(.*?)<\/li>/g) // get all <li>
        ?.map((item) => item.replace(/<\/?li>/g, "").trim()) || []
    );
  }

  return (
    <>
      <div className={`${Style.mainBody} `}>
        <div className={Style.teamSpaceDashboard}>
          <div className={Style.teamSpaceDashboard_main}>
            <div className={Style.teamSpaceDashboard_body}>
              {/* HEADER */}
              <div className={Style.empDirectory_header}>
                <div className={Style.empDirectory_header_left}>
                  {/* filter div */}
                  <TableFilterReturn
                    filterReturn={filterReturn}
                    onChange={(allFilter) => {
                      setFilterReturn(allFilter);
                      getData({ filter: allFilter });
                    }}
                  />
                </div>

                <div className={Style.empDirectory_header_right}>
                  <div className={Style.bpfl_action}>
                    <Tooltip
                      className={Style.bpfl_actionItems}
                      content={"Table Filter"}
                      position={"left center"}
                    >
                      <div
                        className={`${Style.bpfl_actionBtn} ${
                          filterReturn?.length ? Style.active : null
                        }`}
                        onClick={() => {
                          setShowModalFilterTable(true);
                        }}
                      >
                        <div className={Style.icon}>
                          <FilterFunnel01Icon />
                        </div>
                      </div>
                    </Tooltip>

                    <Tooltip
                      className={`${Style.bpfl_actionItems}`}
                      content={"Customize Table"}
                      position={"left center"}
                    >
                      <div
                        className={`${Style.bpfl_actionBtn}`}
                        onClick={() => {
                          setShowModalCustomizeTabs(true);
                        }}
                      >
                        <div className={Style.icon}>
                          <LayoutTopIcon />
                        </div>
                      </div>
                    </Tooltip>
                  </div>
                </div>
              </div>

              {/* BODY */}
              <div className={Style.empDirectory_body}>
                {isLoading ? (
                  <InnerLoader />
                ) : !apiData?.length ? (
                  <div className="flex justify-center items-center w-full h-full">
                    <DataNotFound title={"Products"} />
                  </div>
                ) : (
                  <>
                    <TableCard ref={tableRef}>
                      <Table>
                        <TableHead>
                          <TableRow className="!z-40">
                            <TableCell header sticky className="!z-30">
                              <TableHeaderWrap>
                                <span className="">Package Name</span>
                                <TableSort
                                  field="name"
                                  sortFields={sortFields}
                                  onSort={handleSingleSort}
                                  Style={Style}
                                />
                              </TableHeaderWrap>
                            </TableCell>

                            {tableHeader?.map((eachHead, index) =>
                              eachHead.is_visible === 1 &&
                              eachHead?.show == 1 ? (
                                <TableCell header key={index} className="!z-20">
                                  <TableHeaderWrap>
                                    <span>{eachHead?.value}</span>
                                    {eachHead?.sort_by ? (
                                      <TableSort
                                        field={eachHead?.key}
                                        sortFields={sortFields}
                                        onSort={handleSingleSort}
                                        Style={Style}
                                      />
                                    ) : (
                                      <TableSort
                                        disabled={true}
                                        field={eachHead?.key}
                                        Style={Style}
                                      />
                                    )}
                                  </TableHeaderWrap>
                                </TableCell>
                              ) : null
                            )}
                            {/* <TableCell header className="!z-20">
                              <TableHeaderWrap>
                                <span className="pl-[50px]">Action</span>
                              </TableHeaderWrap>
                            </TableCell> */}
                          </TableRow>
                        </TableHead>

                        <TableBody>
                          {apiData?.map((eachList, index) => {
                            return (
                              <>
                                <TableRow key={`${index}`}>
                                  <TableCell sticky>
                                    <div
                                      className={`${Style.tableActionArea} !gap-4`}
                                    >
                                      <div className="flex items-center gap-3">
                                        <div className="font-medium leading-5 ">
                                          {formatText(eachList?.price_key)}
                                        </div>
                                      </div>

                                      <div
                                        className={
                                          Style.tableActionAreaBtnGrpup
                                        }
                                      >
                                        {/* <div
                                          className={
                                            "w-7 h-7 flex items-center justify-center rounded-md bg-[rgba()] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"
                                          }
                                          onClick={() => {
                                            editProduct(eachList);
                                          }}
                                        >
                                          <div
                                            className={Style.icon}
                                            style={{ color: "#FF9500" }}
                                          >
                                            <NewEditIcon className="h-4.5 w-4.5" />
                                          </div>
                                        </div> */}
                                      </div>
                                    </div>
                                  </TableCell>

                                  {tableHeader?.map((eachHead, i) => {
                                    const features = extractListItems(
                                      eachList?.features_html
                                    );

                                    return eachHead.is_visible === 1 &&
                                      eachHead?.show == 1 ? (
                                      <>
                                        {eachHead.key === "status" ? (
                                          <TableCell
                                            key={`${i}-${index}`}
                                            className="text-center capitalize"
                                          >
                                            {eachList[eachHead.key] == "1" ? (
                                              <StatusChip color="green">
                                                {"Active" || "--"}
                                              </StatusChip>
                                            ) : (
                                              <StatusChip color="red">
                                                {"InActive" || "--"}
                                              </StatusChip>
                                            )}
                                          </TableCell>
                                        ) : eachHead.key === "type" ? (
                                          <TableCell>
                                            {formatText(eachList?.type)}
                                          </TableCell>
                                        ) : eachHead.key === "frequency" ? (
                                          <TableCell>
                                            {formatText(eachList?.frequency)}
                                          </TableCell>
                                        ) : eachHead.key === "features_html" ? (
                                          <TableCell>
                                            <ul className="list-disc list-inside space-y-2">
                                              {features?.map((item, index) => (
                                                <li
                                                  key={index}
                                                  className="marker:text-[#2563eb]"
                                                >
                                                  {item}
                                                </li>
                                              ))}
                                            </ul>
                                          </TableCell>
                                        ) : (
                                          <TableCell key={`${i}-${index}`}>
                                            {eachList[eachHead.key] ?? "--"}
                                          </TableCell>
                                        )}
                                      </>
                                    ) : null;
                                  })}
                                  {/* <TableCell>
                                    <button
                                      onClick={() => {
                                        toggleRow(eachList?.id);
                                      }}
                                      className={`
                                        flex items-center justify-between gap-2
                                        px-3 py-1.5
                                        bg-white hover:bg-white/50
                                        border border-gray-300
                                        rounded-md
                                        text-sm font-medium text-gray-700
                                        transition-all duration-300
                                      `}
                                    >
                                      <span className="flex items-start gap-1">
                                        Packages
                                      </span>
                                      <div
                                        className={`${
                                          openRow == eachList.id
                                            ? "rotate-180"
                                            : ""
                                        } transition-transform duration-300`}
                                      >
                                        <ChevronDownIcon className="h-4.5 w-4.5 text-gray-500" />
                                      </div>
                                    </button>
                                  </TableCell> */}
                                </TableRow>

                                {/* Drill Table */}
                                {/* {openRow == eachList?.id && (
                                  <TableRow
                                    key={`drill-${eachList?.id}`}
                                    className={`${Style.drillRow} !bg-[#F7F7F7] !pr-3`}
                                  >
                                    <TableCell
                                      colSpan={7}
                                      className={"!bg-[#F7F7F7]"}
                                    >
                                      {spLoading ? (
                                        <InnerLoader />
                                      ) : productPackages?.length ? (
                                        <div className="p-3 rounded-lg border border-gray-200 bg-white shadow-sm">
                                          <Table className="w-full border-collapse">
                                            <TableHead>
                                              <TableRow>
                                                <TableCell header>
                                                  <div>Price Key</div>
                                                </TableCell>
                                                <TableCell header>
                                                  Fixed Price
                                                </TableCell>
                                                <TableCell header>
                                                  Frequency
                                                </TableCell>
                                                <TableCell header>
                                                  Min Price
                                                </TableCell>
                                                <TableCell header>
                                                  Max Price
                                                </TableCell>
                                                <TableCell header>
                                                  Features
                                                </TableCell>
                                              </TableRow>
                                            </TableHead>
                                            <TableBody>
                                              {productPackages?.map((sp, i) => {
                                                const features =
                                                  extractListItems(
                                                    sp?.features_html
                                                  );

                                                return (
                                                  <TableRow key={`${i}`}>
                                                    <TableCell sticky>
                                                      <div
                                                        className={`${Style.tableActionArea} !gap-4`}
                                                      >
                                                        <div className="flex items-center gap-3">
                                                          <div className="font-medium leading-5 ">
                                                            {formatText(
                                                              sp?.price_key
                                                            )}
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </TableCell>
                                                    <TableCell>
                                                      {sp?.fixed_price ?? "--"}
                                                    </TableCell>
                                                    <TableCell>
                                                      {formatText(
                                                        sp?.frequency
                                                      ) ?? "--"}
                                                    </TableCell>
                                                    <TableCell>
                                                      {sp?.min_price ?? "--"}
                                                    </TableCell>
                                                    <TableCell>
                                                      {sp?.max_price ?? "--"}
                                                    </TableCell>
                                                    <TableCell>
                                                      <ul className="list-disc list-inside space-y-2">
                                                        {features?.map(
                                                          (item, index) => (
                                                            <li
                                                              key={index}
                                                              className="marker:text-[#2563eb]"
                                                            >
                                                              {item}
                                                            </li>
                                                          )
                                                        )}
                                                      </ul>
                                                    </TableCell>
                                                  </TableRow>
                                                );
                                              })}
                                            </TableBody>
                                          </Table>
                                        </div>
                                      ) : (
                                        <div className="w-full text-center flex justify-center items-center">
                                          <DataNotFound
                                            title={"Product Packages"}
                                          />
                                        </div>
                                      )}
                                    </TableCell>
                                  </TableRow>
                                )} */}
                              </>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </TableCard>
                  </>
                )}
              </div>

              {!isLoading ? (
                apiData?.length > 0 ? (
                  <div
                    className={Style.table_footer}
                    style={{ alignItems: "center" }}
                  >
                    <div className={Style.table_footer_left}>
                      {`showing 1 to ${apiData?.length} of ${
                        tablePagination?.total || apiData?.length
                      }`}
                    </div>

                    {tablePagination ? (
                      <div className={Style.empDirectory_footer}>
                        {tablePagination?.next_page_url ? (
                          <button
                            className={Style.loadMoreBtn}
                            // onClick={() => {
                            //   if (btnLoader) return;
                            //   // setPageCount(pageCount + 1);
                            //   setBtnLoader(true);
                            //   // filterData({ page: pageCount + 1, btnCall: true });
                            //   getData({
                            //     page: tablePagination?.next_page_url,
                            //   });
                            // }}
                            onClick={() => {
                              if (btnLoader) return;
                              setPageCount(pageCount + 1);
                              setBtnLoader(true);
                              filterData({
                                page: pageCount + 1,
                                btnCall: true,
                              });
                            }}
                          >
                            {btnLoader ? (
                              <InnerLoader
                                className={Style.loader}
                                textStatus={false}
                              />
                            ) : (
                              "Load More"
                            )}
                          </button>
                        ) : null}
                      </div>
                    ) : null}

                    <div
                      className={`${Style.table_footer_left} ${Style.rightText}`}
                    ></div>
                  </div>
                ) : null
              ) : (
                <div
                  className={Style.table_footer}
                  style={{ alignItems: "center" }}
                >
                  <div className={Style.table_footer_left}>
                    <Skeleton width={"50%"} height={15} />
                  </div>

                  <div className={Style.empDirectory_footer}>
                    <Skeleton width={"180px"} height={40} />
                  </div>

                  <div
                    className={`${Style.table_footer_left} ${Style.rightText}`}
                  ></div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {showEditModal && (
        <CompanySettingAddUpdate
          onClose={() => {
            setShowEditModal(false);
          }}
          data={currentData}
          onSubmit={onSuccess}
          onError={onError}
          tabIndex={3}
        />
      )}
      {subProductModal && (
        <CompanySettingAddUpdate
          onClose={() => {
            setSubProductModal(false);
          }}
          data={subProductData}
          onSubmit={onSuccess}
          onError={onError}
          tabIndex={4}
        />
      )}
      {showModalFilterTable && (
        <DynamicFilter
          data={filterModalData}
          onClose={() => setShowModalFilterTable(false)}
          returnData={filterReturn}
          // onSave={(filters, filterName, editingFilter) => {
          //   getData({ filter: filters });
          //   setShowModalFilterTable(false);
          //   setFilterReturn(filters);
          // }}
          saveFilter={saveFilter}
          apiUrl="sales/packages-products"
          onSave={(filters, filterName, editingFilter) => {
            setShowModalFilterTable(false);
            setFilterReturn(filters ? filters : []);
            setSelectFilterName(filterName ? filterName : "My Filter");
            setEditingFilters(editingFilter ? editingFilter : []);
            setPageCount(1);
            filterData({ filters: filters, page: 1 });
          }}
          selectFilterName={selectFilterName}
          editingFilters={editingFilters}
        />
      )}

      {showModalCustomizeTabs && (
        <CustomizeTabsPopup
          data={tableHeader}
          onClose={() => {
            setShowModalCustomizeTabs(false);
            const table = tableRef?.current;
            if (table) {
              table.style.zIndex = 1;
            }
          }}
          onPreview={(updatedHeaders) => {
            setTableHeader(updatedHeaders);
            const table = tableRef?.current;
            table.style.zIndex = 100;
          }}
          onPreviewClose={() => {
            const table = tableRef?.current;
            table.style.zIndex = 1;
          }}
          onSave={(saveHeaders) => {
            setTableHeader(saveHeaders);
            const table = tableRef?.current;
            if (table) {
              table.style.zIndex = 1;
            }
          }}
          apiUrl="sales/packages-products"
        />
      )}

      <Snackbar
        open={alertData?.isShow}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={alertData?.type}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {alertData?.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default SettingsProductsPackages;
